import { Form } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

interface ChequeProps {
  numero: string;
  banque: string;
  tireur: string;
  montant: number;
}

const Cheque = (props: ChequeProps) => {
  const {
    numero: numeroProps,
    banque: banqueProps,
    tireur: tireurProps,
    montant: montantProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Chèque</label>
      </Form.Field>
      <Form.Field inline width={2}>
        N°
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        Banque
        {' : '}
        <label>{banqueProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        Tireur
        {' : '}
        <label>{tireurProps}</label>
      </Form.Field>
      <Form.Field
        inline
        width={4}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Cheque;
